import { api } from './../../api.js';
import { config } from './../../config.js';

const state = {
    carrito: null,
    carritoItems: [],
    aviso: false,
    timer: null 
};

const mutations = {
    SET_CARRITO_ACTIVO(state, carrito) {
        state.carrito = carrito;
    },
    SET_CARRITO_ITEMS(state, items) {
        state.carritoItems = items;
    },
    SET_AVISO(state, aviso) {
        state.aviso = aviso;
    },
    DECREMENT_SECONDS_LEFT(state) {
        if (state.carrito && state.carrito.seconds_left > 0) {
            state.carrito.seconds_left -= 1;
        }
    },
    CLEAR_TIMER(state) {
        if (state.timer) {
            clearInterval(state.timer);
            state.timer = null;
        }
    }
};

const getters = {
    getCarritoActivoOnline: state => state.carrito,
    getCarritoItemsOnline: state => state.carritoItems,
    getAvisoOnline: state => state.aviso,
};

const actions = {
    USUARIO_CARRITO_CREAR: function({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.crear'), data).then(res => {
                commit('SET_CARRITO_ACTIVO', res.data.data);
                resolve(res);
                dispatch('START_CART_TIMER');
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_ACTIVO: function({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.activo'), data).then(res => {
                const carrito = res.data.data;
                commit('SET_CARRITO_ACTIVO', carrito);

                const params = { cart_id: carrito.id, filters: { uuid: localStorage.getItem('uuid') }};
                this.dispatch('USUARIO_CARRITO_ITEMS', params).then(itemsRes => {
                    commit('SET_CARRITO_ITEMS', itemsRes.data);
                    resolve(res);
                    dispatch('START_CART_TIMER');
                });
            }).catch(error => {
                commit('SET_CARRITO_ACTIVO', null);
                commit('SET_CARRITO_ITEMS', []);
                console.log(error);
                reject(error);
            });
        });
    },
    START_CART_TIMER: function({ commit, state, dispatch }) {
        commit('CLEAR_TIMER');

        const timer = setInterval(() => {
            if (state.carrito && state.carrito.seconds_left > 0) {
                commit('DECREMENT_SECONDS_LEFT');
            } else if(state.carrito) {
                dispatch('USUARIO_CARRITO_DELETE', { cart_id: state.carrito.id, filters: { uuid: localStorage.getItem('uuid') } });
                commit('CLEAR_TIMER');
            }
        }, 1000);

        state.timer = timer;
    },
    USUARIO_CARRITO_ITEMS: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.items'), data).then(res => {
                commit('SET_CARRITO_ITEMS', res.data);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_PRODUCTOS: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.productos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_PRODUCTOS_ADD_PRODUCTS: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.productos.add-products'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_PRODUCTOS_UPDATE_PRODUCTS: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.productos.update-products'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_PRODUCTOS_DELETE_PRODUCTS: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.productos.delete-products'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_PRODUCTOS_DELETE: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.productos.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_ADD_ITEMS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.add-items'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_DELETE_ITEMS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.delete-items'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_GUARDAR_DATOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.guardar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    USUARIO_CARRITO_DELETE: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('usuario.carrito.delete'), data).then(res => {
                commit('SET_CARRITO_ACTIVO', null);
                commit('SET_CARRITO_ITEMS', []);
                commit('CLEAR_TIMER');
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    AVISO_CARRITO({ commit }, valor) {
        commit('SET_AVISO', valor);
    }
};

export default {
    state,
    mutations,
    getters,
    actions
};
